import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const volumes = [{
  title: 'FOUNDATION TRAINING SYSTEM',
  subtitle: 'U9–U11',
  description: 'Build strong fundamental cricket skills from day one and introduce players to the game through structured, age-appropriate coaching.'
}, {
  title: 'DEVELOPMENT TRAINING SYSTEM',
  subtitle: 'U13–U15',
  description: 'Accelerate technical ability, consistency, tactical awareness, and match-play understanding.'
}, {
  title: 'PERFORMANCE TRAINING SYSTEM',
  subtitle: 'U17–U19',
  description: 'High-performance player development with advanced technical, tactical, and highly competitive match training.'
}, {
  title: '365 PRACTICE SESSION LIBRARY',
  subtitle: 'All Age Groups',
  description: 'A complete, ready-to-use training library covering all age groups and multiple coaching situations. Structured cricket sessions ready to run.'
}, {
  title: 'MATCH DAY COACHING SYSTEM',
  subtitle: 'Game Management',
  description: 'Complete match preparation, game management, captaincy development, tactical decision-making, and strategic competition planning.'
}, {
  title: 'SEASON MANAGEMENT SYSTEM',
  subtitle: 'Season Blueprint',
  description: 'The complete season blueprint built on the 6 pillars of coaching success: Plan, Train, Compete, Evaluate, Develop, and Manage.'
}];
export function Volumes() {
  return <section className="py-20 bg-navy-950 relative" data-id="element-256">
      <div className="container mx-auto px-4" data-id="element-257">
        <div className="text-center mb-16" data-id="element-258">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-259">
            THE COMPLETE 6-VOLUME SYSTEM
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-260">
          {volumes.map((vol, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gradient-to-b from-navy-800 to-navy-900 border border-navy-700 rounded-xl p-8 relative overflow-hidden group hover:border-gold-500/50 transition-colors" data-id="element-261">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-262">
                <BookOpen className="w-24 h-24 text-white" data-id="element-263" />
              </div>
              <div className="relative z-10" data-id="element-264">
                <div className="flex items-center gap-2 mb-2" data-id="element-265">
                  <span className="text-gold-500 font-oswald text-sm tracking-widest" data-id="element-266">
                    VOLUME {index + 1}
                  </span>
                  <span className="text-navy-950 bg-gold-500 font-oswald text-xs font-bold tracking-wider px-2 py-0.5 rounded" data-id="element-267">
                    {vol.subtitle}
                  </span>
                </div>
                <h3 className="font-anton text-2xl text-white uppercase tracking-wide mb-4" data-id="element-268">
                  {vol.title}
                </h3>
                <p className="text-gray-400 font-medium leading-relaxed" data-id="element-269">
                  {vol.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}